import type React from 'react';
import { Fragment } from 'react';

import { useWindowsStore } from '../../+state/store';
import type { Windows } from '../../+state/windows/window.model';
import {
    getMicrofrontendByWindow,
    type IMicrofrontendDefinition,
} from '../../microfrontends';
import { Microfrontend } from '../Microfrontend';
import { Window } from './Window';

export const WindowList: React.FC = () => {
    const openWindows = useWindowsStore((state) => state.openWindows);
    const closeWindow = useWindowsStore((state) => state.closeWindow);
    const focusWindow = useWindowsStore((state) => state.focusWindow);
    const minimizeWindow = useWindowsStore((state) => state.minimizeWindow);

    const renderWindow = (
        window: Windows,
        definition: IMicrofrontendDefinition,
    ) => (
        <Window
            className={(definition.classes ?? []).join(' ')}
            key={definition.name}
            title={definition.label}
            onFocus={() => focusWindow(window)}
            onMinimize={() => minimizeWindow(window)}
            onClose={() => closeWindow(window)}
        >
            <Microfrontend name={definition.name} />
        </Window>
    );

    return (
        <Fragment>
            {openWindows.map((window) => {
                const definition = getMicrofrontendByWindow(window);
                return definition ? renderWindow(window, definition) : null;
            })}
        </Fragment>
    );
};
